<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <button
                        type="button"
                        id="export-table"
                        @click="onexport"
                        class="btn btn-success"
                        style="margin-bottom:5px"
                        >Download Excel</button
                    >
                    <div class="scrollable-table">
                        <table class="table table-centered  table-bordered" id="titledExcel" style="overflow-x: auto">
                            <thead>
                                <tr>
                                    <th>Sl.</th>
                                    <th>EP ID No.</th>
                                    <th>EP's Name</th>
                                    <th>Father's/Husband Name</th>
                                    <th>Mother's Name</th>
                                    <th>Award Book No.</th>
                                    <th>Mouza</th>
                                    <th>LA Case No.</th>
                                    <th>Plot No.</th>
                                    <th>Land Type</th>
                                    <th>Land Affected (Decimal)</th>
                                    <th>Additional Grand For Land(AGL)</th>
                                    <th>Total AGL</th>
                                    <th>TG</th>
                                    <th>RG</th>
                                    <th>AGWB</th>
                                    <th>RRC</th>
                                    <th>AGS</th>
                                    <th>TG PCR/CPR</th>
                                    <th>DRG PCR/CPR</th>
                                    <th>AGT</th>
                                    <th>CGVFT</th>
                                    <th>CGSCFS</th>
                                    <th>CGSLL</th>
                                    <th>RVS</th>
                                    <th>CGBIT</th>
                                    <th>CGEE</th>
                                    <th>RARO</th>
                                    <th>RARI</th>
                                    <th>MG</th>
                                    <th>CGVM</th>
                                    <th>CGVFH</th>
                                    <th>CGNUC</th>
                                    <th>CGLIP</th>
                                    <th>CGUAI</th>
                                    <th>Power Group</th>
                                    <th>Total Amount</th>
                                    <th>Payable Amount</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(prepare_estimate, index) in prepare_estimates">
                                    <tr
                                        v-for="(land, key) in prepare_estimate.lands"
                                        :key="key"
                                        :style="prepare_estimate.style"
                                    >
                                        <template v-if="key == 0">
                                            <td :rowspan="prepare_estimate.total_row">{{ index + 1 }}</td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                epIdWithPaymentStatus(
                                                    prepare_estimate.ep_id.ep_id,
                                                    prepare_estimate.ep_id.is_paid
                                                )
                                            }}</td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <router-link
                                                    :to="{ name: 'sesView', params: { ses_id: prepare_estimate.id } }"
                                                    tag="a"
                                                    target="_blank"
                                                    >{{ prepare_estimate.name }}</router-link
                                                >
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'F'"
                                                ></div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'H'"
                                                    >Husband Name:
                                                </div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'S'"
                                                    >Spouse Name:</div
                                                >
                                                {{ prepare_estimate.father_husband_name }}
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.mother_name
                                            }}</td>
                                        </template>

                                        <td
                                            ><span style="margin-left: 5px"
                                                >{{ land.ccl_land.ccl.book_no
                                                }}{{
                                                    land.ccl_land.ccl.book_sub_no != null
                                                        ? '/' + land.ccl_land.ccl.book_sub_no
                                                        : ''
                                                }}</span
                                            ></td
                                        >
                                        <td>{{ land.mouza !== null ? land.mouza.mouza_desc : '' }}</td>
                                        <td
                                            ><span style="margin-left: 5px;">{{
                                                land.ccl_land.ccl.la_case != null
                                                    ? land.ccl_land.ccl.la_case.la_case_desc
                                                    : ''
                                            }}</span></td
                                        >
                                        <td>{{ land.plot_no }}</td>
                                        <td>{{ land.land_type.land_type_desc }}</td>
                                        <td>{{ land.self_affected }}</td>
                                        <td>{{ land.current_agl }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_AGL
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_TG
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_RG
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_AGWB
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_RRC
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_AGS
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                            >{{ prepare_estimate.amount_TG_PCR_CPR }}
                                        </td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                            >{{ prepare_estimate.amount_DRG_PCR_CPR }}
                                        </td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_AGT
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGVFT
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGSCFS
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGSLL
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_RVS
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                            >{{ prepare_estimate.amount_CGIDCIP }}
                                        </td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGEE
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_RARO
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_RARI
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_MG
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGVMH
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGVFH
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGNUC
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                            prepare_estimate.amount_CGLIP
                                        }}</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row">0.00</td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                            >{{ prepare_estimate.power_group_id }}
                                        </td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                            >{{ prepare_estimate.total_amount_EP }}
                                        </td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                            >{{ prepare_estimate.totalAmountPower }}
                                        </td>
                                        <td v-if="key === 0" :rowspan="prepare_estimate.total_row"></td>
                                    </tr>

                                    <tr
                                        v-for="(structure, key) in prepare_estimate.structures"
                                        :key="key"
                                        :style="prepare_estimate.style"
                                    >
                                        <template v-if="key == 0 && prepare_estimate.lands.length == 0">
                                            <td :rowspan="prepare_estimate.total_row">{{ index + 1 }}</td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.ep_id.ep_id
                                            }}</td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <router-link
                                                    :to="{ name: 'sesView', params: { ses_id: prepare_estimate.id } }"
                                                    tag="a"
                                                    target="_blank"
                                                    >{{ prepare_estimate.name }}</router-link
                                                >
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'F'"
                                                ></div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'H'"
                                                    >Husband Name:
                                                </div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'S'"
                                                    >Spouse Name:</div
                                                >
                                                {{ prepare_estimate.father_husband_name }}
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.mother_name
                                            }}</td>
                                        </template>

                                        <td
                                            ><span
                                                style="margin-left: 5px"
                                                v-if="structure.ccl_structure && structure.ccl_structure.ccl"
                                                >{{ structure.ccl_structure.ccl.book_no
                                                }}{{
                                                    structure.ccl_structure.ccl.book_sub_no != null
                                                        ? '/' + structure.ccl_structure.ccl.book_sub_no
                                                        : ''
                                                }}</span
                                            ></td
                                        >
                                        <td
                                            ><span v-if="structure.land !== null">{{
                                                structure.land.mouza.mouza_desc
                                            }}</span></td
                                        >
                                        <td
                                            ><span style="margin-left: 5px">{{
                                                structure.ccl_structure != null
                                                    ? structure.ccl_structure.ccl
                                                        ? structure.ccl_structure.ccl.la_case.la_case_desc
                                                        : ''
                                                    : ''
                                            }}</span></td
                                        >
                                        <td
                                            ><span v-if="structure.land !== null">{{
                                                structure.land.plot_no
                                            }}</span></td
                                        >
                                        <td>Structure</td>
                                        <td>0.00</td>
                                        <td>0.00</td>

                                        <template v-if="prepare_estimate.lands.length == 0">
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGL
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_TG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGWB
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RRC
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGS
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_TG_PCR_CPR
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_DRG_PCR_CPR
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGT
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVFT }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGSCFS }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGSLL }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RVS
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGIDCIP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_CGEE
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RARO
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RARI
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_MG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVMH }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVFH }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGNUC }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGLIP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">0.00</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.power_group_id }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.total_amount_EP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.totalAmountPower }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"></td>
                                        </template>
                                    </tr>

                                    <tr
                                        v-for="(tree, key) in prepare_estimate.trees"
                                        :key="key"
                                        :style="prepare_estimate.style"
                                    >
                                        <template
                                            v-if="
                                                key == 0 &&
                                                    prepare_estimate.structures.length == 0 &&
                                                    prepare_estimate.lands.length == 0
                                            "
                                        >
                                            <td :rowspan="prepare_estimate.total_row">{{ index + 1 }}</td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.ep_id.ep_id
                                            }}</td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <router-link
                                                    :to="{ name: 'sesView', params: { ses_id: prepare_estimate.id } }"
                                                    tag="a"
                                                    target="_blank"
                                                    >{{ prepare_estimate.name }}</router-link
                                                >
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'F'"
                                                ></div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'H'"
                                                    >Husband Name:
                                                </div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'S'"
                                                    >Spouse Name:</div
                                                >
                                                {{ prepare_estimate.father_husband_name }}
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.mother_name
                                            }}</td>
                                        </template>

                                        <td
                                            ><span style="margin-left: 5px" v-if="tree.ccl_tree && tree.ccl_tree.ccl"
                                                >{{ tree.ccl_tree.ccl.book_no
                                                }}{{
                                                    tree.ccl_tree.ccl.book_sub_no != null
                                                        ? '/' + tree.ccl_tree.ccl.book_sub_no
                                                        : ''
                                                }}</span
                                            ></td
                                        >
                                        <td
                                            ><span v-if="tree.land !== null">{{ tree.land.mouza.mouza_desc }}</span></td
                                        >
                                        <td
                                            ><span style="margin-left: 5px" v-if="tree.ccl_tree">{{
                                                tree.ccl_tree != null
                                                    ? tree.ccl_tree.ccl
                                                        ? tree.ccl_tree.ccl.la_case.la_case_desc
                                                        : ''
                                                    : ''
                                            }}</span></td
                                        >
                                        <td
                                            ><span v-if="tree.land !== null">{{ tree.land.plot_no }}</span></td
                                        >
                                        <td>Tree</td>
                                        <td>0.00</td>
                                        <td>0.00</td>

                                        <template
                                            v-if="
                                                prepare_estimate.lands.length == 0 &&
                                                    prepare_estimate.structures.length == 0
                                            "
                                        >
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGL
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_TG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGWB
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RRC
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGS
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_TG_PCR_CPR
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_DRG_PCR_CPR
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGT
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVFT }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGSCFS }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGSLL }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RVS
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGIDCIP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_CGEE
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RARO
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RARI
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_MG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVMH }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVFH }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGNUC }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGLIP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">0.00</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.power_group_id }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.total_amount_EP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.totalAmountPower }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"></td>
                                        </template>
                                    </tr>
                                    <tr
                                        v-for="(crop, key) in prepare_estimate.crops"
                                        :key="key"
                                        :style="prepare_estimate.style"
                                    >
                                        <template
                                            v-if="
                                                key == 0 &&
                                                    prepare_estimate.trees.length == 0 &&
                                                    prepare_estimate.structures.length == 0 &&
                                                    prepare_estimate.lands.length == 0
                                            "
                                        >
                                            <td :rowspan="prepare_estimate.total_row">{{ index + 1 }}</td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.ep_id.ep_id
                                            }}</td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <router-link
                                                    :to="{ name: 'sesView', params: { ses_id: prepare_estimate.id } }"
                                                    tag="a"
                                                    target="_blank"
                                                    >{{ prepare_estimate.name }}</router-link
                                                >
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'F'"
                                                ></div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'H'"
                                                    >Husband Name:
                                                </div>
                                                <div
                                                    style="font-weight:bold"
                                                    v-if="prepare_estimate.father_hus_type === 'S'"
                                                    >Spouse Name:</div
                                                >
                                                {{ prepare_estimate.father_husband_name }}
                                            </td>
                                            <td :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.mother_name
                                            }}</td>
                                        </template>

                                        <td
                                            ><span style="margin-left: 5px" v-if="crop.ccl_crop.ccl"
                                                >{{ crop.ccl_crop.ccl.book_no
                                                }}{{
                                                    crop.ccl_crop.ccl.book_sub_no != null
                                                        ? '/' + crop.ccl_crop.ccl.book_sub_no
                                                        : ''
                                                }}</span
                                            >
                                        </td>
                                        <td
                                            ><span v-if="crop.land !== null">{{ crop.land.mouza.mouza_desc }}</span></td
                                        >
                                        <td
                                            ><span style="margin-left: 5px" v-if="crop.ccl_crop">{{
                                                crop.ccl_crop != null
                                                    ? crop.ccl_crop.ccl
                                                        ? crop.ccl_crop.ccl.la_case.la_case_desc
                                                        : ''
                                                    : ''
                                            }}</span></td
                                        >
                                        <td
                                            ><span v-if="crop.land !== null">{{ crop.land.plot_no }}</span></td
                                        >
                                        <td>Crop</td>
                                        <td>0.00</td>
                                        <td>0.00</td>

                                        <template
                                            v-if="
                                                prepare_estimate.lands.length == 0 &&
                                                    prepare_estimate.structures.length == 0 &&
                                                    prepare_estimate.trees.length == 0
                                            "
                                        >
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGL
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_TG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGWB
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RRC
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGS
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_TG_PCR_CPR
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_DRG_PCR_CPR
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_AGT
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVFT }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGSCFS }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGSLL }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RVS
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGIDCIP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_CGEE
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RARO
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_RARI
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">{{
                                                prepare_estimate.amount_MG
                                            }}</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVMH }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGVFH }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGNUC }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.amount_CGLIP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row">0.00</td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.power_group_id }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.total_amount_EP }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"
                                                >{{ prepare_estimate.totalAmountPower }}
                                            </td>
                                            <td v-if="key === 0" :rowspan="prepare_estimate.total_row"></td>
                                        </template>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import XLSX from 'xlsx'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
    page: {
        title: 'Estimate calculation',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: 'Search SES',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'SES',
                    active: true,
                },
            ],
            prepare_estimates: [],
        }
    },

    mounted() {
        this.prepareEstimate()
    },
    methods: {
        epIdWithPaymentStatus: epIdWithPaymentStatus,
        prepareEstimate() {
            let ses_eps = this.$route.query.ses_eps
            let ses_power_group_ids = this.$route.query.ses_power_group_ids
            http.post('api/estimate/create', { ses_eps: ses_eps, ses_power_group_ids: ses_power_group_ids }).then(
                (response) => {
                    this.prepare_estimates = response.data.prepare_estimates
                }
            )
        },
        onexport(evt) {
            var tbl = document.getElementById('titledExcel')
            console.log(tbl)
            var wb = XLSX.utils.table_to_book(tbl, {
                raw: true,
                NumberFormat: 'string',
                cellDates: false,
            })
            XLSX.writeFile(wb, 'estimate-title.xlsx')
        },
    },
}
</script>
<style>
.scrollable-table {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
